import React from 'react'
import './admin-tasks.css'
import {ErrorPopup} from '../ErrorPopup/ErrorPopup'
import Axios from 'axios'
import WorkflowDropDown from '../WorkflowDropDown/WorkflowDropDown'
import { baseUrl } from '../assets/Animations'
import loadingping from '.././img/loadingpin.svg'
import TaskCardModal2023 from '../TaskCardModal2023/TaskCardModal2023'
import { calculateTasksDueToday, freshTask } from './adminTaskUtils'
import TaskChip2023 from './TaskChip2023/TaskChip2023'
import WorkflowChip2023 from './WorkflowChip2023/WorkflowChip2023'
import WorkflowCardModal2023 from '../WorfklowCardModal2023/WorkflowCardModal2023'
import WorkflowTemplateModal from './WorkflowTemplateModal/WorkflowTemplateModal'

const AdminTasks = (props) => {
    const myToken = localStorage.getItem('token')
    const myHeader = {headers: { Authorization: `Bearer ${myToken}` }}

    const [openModal2023, setOpenModal2023] = React.useState(false)
    const [openWorkflowModal2023, setOpenWorkflowModal2023] = React.useState(false)
    const [workflowTemplateModal2023, setWorkflowTemplateModal2023] = React.useState(false)
    const [error, setError] = React.useState(false)
    const [taskTab, setTaskTab] = React.useState('past')
    const [workTab, setWorkTab] = React.useState('work-past')
    const [workflowDropdownOpen, setWorkflowDropdownOpen] = React.useState(false)
    const [editWorkflow, setEditWorkflow] = React.useState(false)
    const [workflows, setWorkflows] = React.useState([])
    const [numberBriDueToday, setNumberBriDueToday] = React.useState(0)
    const [numberCourtneyDueToday, setNumberCourtneyDueToday] = React.useState(0)
    const [loading1, setLoading1] = React.useState(false)
    const [loading2, setLoading2] = React.useState(false)

    React.useEffect(() => {
        getTasksAndWorkflows();
    },[])

    React.useEffect(() => {
        document.getElementById(taskTab) && (document.getElementById(taskTab).style.borderBottom = "1px solid #fff")
        document.getElementById(workTab) && (document.getElementById(workTab).style.borderBottom = "1px solid #fff")
    }, [workTab, taskTab])

    React.useEffect(() => {
        calculateTasksDueToday(props.todos, workflows, setNumberBriDueToday, setNumberCourtneyDueToday)   
    }, [props.todos, workflows])

    const getTasksAndWorkflows = async () => {
        setLoading1(true)
        setLoading2(true)
        try{
            const {data, status} = await Axios.get(`${baseUrl}/tasks`, myHeader)
            if(status === 201 || status === 200) {
                props.setTodos([...data])
                setLoading1(false)
            } else {
                setError({message: 'Refresh. If error persists send a screenshot to Prescott', status: status})
            }
        } catch(e) {
            setError({message: e.response.data, status: e.response.status})
        }

        try{
            const {data, status} = await Axios.get(`${baseUrl}/workflows`, myHeader)
            if(status === 201 || status === 200) {
                setWorkflows([...data])
                setLoading2(false)
            } else {
                setError({message: 'Refresh. If error persists send a screenshot to Prescott', status: status})
            }
        } catch(e) {
            setError({message: e.response.data, status: e.response.status})
        }
    }

    const openModalFunction2023 = (workflow) => {
        setWorkflows(prev => ([...prev, workflow]))
        setOpenWorkflowModal2023(workflow)
        props.getNotesAboutModal(workflow.todoId, 'tasksId', workflow.todoName)
    }

    const changeTab = (tar) => {
        document.getElementById(taskTab).style.borderBottom = "none"
        setTaskTab(tar)
    }
    const changeWorkTab = (tar) => {
        document.getElementById(workTab).style.borderBottom = "none"
        setWorkTab(tar)
    }
    const toggleWorkflowDropdown = () => {
        setWorkflowDropdownOpen(prev => !prev)
    }

    const editAWorkflow = async (id) => {
        const {data, status} = await Axios.get(`${baseUrl}/templates/${id}`, myHeader)
        if(status === 201 || status === 200) {
            toggleWorkflowDropdown()
            setEditWorkflow(true)
            setWorkflowTemplateModal2023({...data})
        } else {console.log(status)}
    }

    const openANewWorkflow = async (id) => {
        const {data, status} = await Axios.get(`${baseUrl}/templates/${id}`, myHeader)
        if(status === 201 || status === 200) {
            setWorkflowDropdownOpen(false)
            const res = await Axios.post(`${baseUrl}/workflows`, {
                todoId: Math.random().toString(16).slice(2),
                todoName: data.todoName,
                todoDescription: data.todoDescription,
                instrumentList: data.instrumentList ? data.instrumentList : [],
                teacherList: data.teacherList ? data.teacherList : [],
                todoDueDate: new Date(),
                todoAlarm: data.todoAlarm,
                todoOwner: data.todoOwner,
                whichList: data.whichList,
                whichSchool: data.whichSchool,
                todoSubtasks: data.todoSubtasks
            }, myHeader)
            if(res.status === 201 || status === 200) {
                openModalFunction2023({...res.data})
            } else {console.log(res.status)}
        } else {console.log(status)}
    }

    const createNewTask2023 = () => {
        Axios.post(`${baseUrl}/tasks`, freshTask(), myHeader)
        .then((res) => {
            props.setTodos(prev => ([...prev, res.data]))
            setOpenModal2023(res.data)
        })
        .catch((err) => console.log(err))
    }

    return (
        <div className="admin-task-page">
            <div className="admin-tasks__top-btn-wrapper">
                <div className="admin-tasks__top-btn-wrapper__title">Tasks</div>
                <div className="admin-tasks__add-task" onClick={() => createNewTask2023()}>+ Add Task</div>
                <div className="admin-tasks__add-task" onClick={() => toggleWorkflowDropdown()}>+ Add Workflow</div>
                {workflowDropdownOpen && <WorkflowDropDown  toggleWorkflowDropdown={toggleWorkflowDropdown} setWorkflowTemplateModal2023={setWorkflowTemplateModal2023} setEditWorkflow={editAWorkflow} openANewWorkflow={openANewWorkflow} />}
            </div>
            <div className='admin-tasks__columns'>
                <div className='admin-tasks__columns__title'>🚨 Up For Grabs 🚨</div>
                <div className="tasks-area-scroll">
                    <div className='admin-tasks__overdue-tasks__wrapper' style={{height: '38px'}}></div>
                    <div className="past-due-task-list">
                        {loading1 && props.todos.length === 0 ? <img className="loading-ping" src={loadingping} /> :
                            <div>
                                {props.todos.map(todo => (todo.todoOwner === '' || todo.todoOwner === 'Everyone')  && <TaskChip2023 key={todo.todoId} todo={todo} setOpenModal2023={setOpenModal2023} setTodos={props.setTodos} getNotesAboutModal={props.getNotesAboutModal}/>)}
                                {workflows.map(workflow => (workflow.todoOwner === '' || workflow.todoOwner === 'Everyone') && <WorkflowChip2023 key={workflow.todoId} workflow={workflow} setOpenWorkflowModal2023={setOpenWorkflowModal2023} getNotesAboutModal={props.getNotesAboutModal} />)}
                            </div>
                        }
                    </div>   
                </div>
            </div>
            <div className="admin-tasks__columns">
                <img className='admin-tasks__columns__admin-pic' src='https://app.atharo.app/brimassie.jpg' />
                <div className="tasks-area-scroll">
                    <div className='admin-tasks__overdue-tasks__wrapper'>
                        <div className="admin-tasks__overdue-tasks" id="past" onClick={() => changeTab('past')}>In Progress</div>
                        <div className="admin-tasks__overdue-tasks" id="today" onClick={() => changeTab('today')}>{numberBriDueToday > 0 ? <div className="admin-tasks__due-today-notification">{numberBriDueToday}</div> : null} Due Today</div>
                        <div className="admin-tasks__overdue-tasks" id="later" onClick={() => changeTab('later')}>Due Later</div>
                    </div>
                    <div className="past-due-task-list">
                        {taskTab === 'past' && <div>
                        {
                            loading1 && props.todos.length === 0
                            ? 
                            <img className="loading-ping" src={loadingping} /> 
                            :
                            <div>
                                {props.todos.map(todo => new Date(todo.todoDueDate) < new Date().setHours(1,0,0,0)  && todo.todoOwner === 'Bri' && <TaskChip2023 key={todo.todoId} todo={todo} setOpenModal2023={setOpenModal2023} setTodos={props.setTodos} getNotesAboutModal={props.getNotesAboutModal}/>)}
                                {workflows.map(todo => new Date(todo.todoDueDate) < new Date().setHours(1,0,0,0)  && todo.todoOwner === 'Bri' && <WorkflowChip2023 key={todo.todoId} workflow={todo} setOpenWorkflowModal2023={setOpenWorkflowModal2023} getNotesAboutModal={props.getNotesAboutModal} /> )}
                            </div>
                        }
                        </div>}
                        {taskTab === 'today' && 
                            <div>
                                {props.todos.map(todo => new Date(todo.todoDueDate) < new Date(new Date().setDate(new Date().getDate()+1)).setHours(1,0,0,0) && new Date(todo.todoDueDate) > new Date().setHours(1,0,0,0) && todo.todoOwner === 'Bri' && <TaskChip2023 key={todo.todoId} todo={todo} setOpenModal2023={setOpenModal2023} setTodos={props.setTodos} getNotesAboutModal={props.getNotesAboutModal}/>)}
                                {workflows.map(todo => new Date(todo.todoDueDate) < new Date(new Date().setDate(new Date().getDate()+1)).setHours(1,0,0,0) && new Date(todo.todoDueDate) > new Date().setHours(1,0,0,0) && todo.todoOwner === 'Bri' && <WorkflowChip2023 key={todo.todoId} workflow={todo} setOpenWorkflowModal2023={setOpenWorkflowModal2023} getNotesAboutModal={props.getNotesAboutModal} />)}
                            </div>
                        }
                        {taskTab === 'later' && 
                            <div>
                                {props.todos.map(todo => new Date(todo.todoDueDate) > new Date(new Date().setDate(new Date().getDate()+1)).setHours(1,0,0,0)  && todo.todoOwner === 'Bri' && <TaskChip2023 key={todo.todoId} todo={todo} setOpenModal2023={setOpenModal2023} setTodos={props.setTodos} getNotesAboutModal={props.getNotesAboutModal}/>)}
                                {workflows.map(todo => new Date(todo.todoDueDate) > new Date(new Date().setDate(new Date().getDate()+1)).setHours(1,0,0,0)  && todo.todoOwner === 'Bri' && <WorkflowChip2023 key={todo.todoId} workflow={todo} setOpenWorkflowModal2023={setOpenWorkflowModal2023} getNotesAboutModal={props.getNotesAboutModal} />)}
                            </div>
                        }
                    </div>         
                </div>
            </div>
            <div className="admin-tasks__columns">
                <img className='admin-tasks__columns__admin-pic' src='https://app.atharo.app/courtneymalloy.jpg' />
                <div className="tasks-area-scroll">
                    <div className='admin-tasks__overdue-tasks__wrapper'>
                        <div className="admin-tasks__overdue-tasks" id="work-past" onClick={() => changeWorkTab('work-past')}>In Progress</div>
                        <div className="admin-tasks__overdue-tasks" id="work-today" onClick={() => changeWorkTab('work-today')}>{numberCourtneyDueToday > 0 ? <div className="admin-tasks__workflows__due-today-notification">{numberCourtneyDueToday}</div> : null} Due Today</div>
                        <div className="admin-tasks__overdue-tasks" id="work-later" onClick={() => changeWorkTab('work-later')}>Due Later</div>
                    </div>
                    <div className="past-due-task-list">
                        {workTab === 'work-past' && 
                            <div>
                                { loading2 && workflows.length === 0 ? <img className="loading-ping" src={loadingping} /> :
                                    <div>
                                        {props.todos.map(todo => new Date(todo.todoDueDate) < new Date().setHours(1,0,0,0) && todo.todoOwner === 'Courtney' && <TaskChip2023 key={todo.todoId} todo={todo} setOpenModal2023={setOpenModal2023} setTodos={props.setTodos} getNotesAboutModal={props.getNotesAboutModal}/>)}
                                        {workflows.map(todo => new Date(todo.todoDueDate) < new Date().setHours(1,0,0,0) && todo.todoOwner === 'Courtney' && <WorkflowChip2023 key={todo.todoId} workflow={todo} setOpenWorkflowModal2023={setOpenWorkflowModal2023} getNotesAboutModal={props.getNotesAboutModal} />)}
                                    </div>
                                }
                            </div>
                        }
                        {workTab === 'work-today' && 
                            <div>
                                {props.todos.map(todo => new Date(todo.todoDueDate) < new Date(new Date().setDate(new Date().getDate()+1)).setHours(1,0,0,0) && new Date(todo.todoDueDate) > new Date().setHours(1,0,0,0) && todo.todoOwner === 'Courtney' && <TaskChip2023 key={todo.todoId} todo={todo} setOpenModal2023={setOpenModal2023} setTodos={props.setTodos} getNotesAboutModal={props.getNotesAboutModal}/>)}
                                {workflows.map(todo => new Date(todo.todoDueDate) < new Date(new Date().setDate(new Date().getDate()+1)).setHours(1,0,0,0) && new Date(todo.todoDueDate) > new Date().setHours(1,0,0,0) && todo.todoOwner === 'Courtney' && <WorkflowChip2023 key={todo.todoId} workflow={todo} setOpenWorkflowModal2023={setOpenWorkflowModal2023} getNotesAboutModal={props.getNotesAboutModal} />)}
                            </div>
                        }
                        {workTab === 'work-later' && 
                            <div>
                                {props.todos.map(todo => new Date(todo.todoDueDate) > new Date(new Date().setDate(new Date().getDate()+1)).setHours(1,0,0,0) && todo.todoOwner === 'Courtney' && <TaskChip2023 key={todo.todoId} todo={todo} setOpenModal2023={setOpenModal2023} setTodos={props.setTodos} getNotesAboutModal={props.getNotesAboutModal}/>)}
                                {workflows.map(todo => new Date(todo.todoDueDate) > new Date(new Date().setDate(new Date().getDate()+1)).setHours(1,0,0,0) && todo.todoOwner === 'Courtney' && <WorkflowChip2023 key={todo.todoId} workflow={todo} setOpenWorkflowModal2023={setOpenWorkflowModal2023} getNotesAboutModal={props.getNotesAboutModal} />)}
                            </div>
                        }
                    </div>    
                </div>
            </div>
            {openModal2023 && <TaskCardModal2023 key={openModal2023.todoId} setOpenModal2023={setOpenModal2023} openModal2023={openModal2023} setTodos={props.setTodos} setShowNotes={props.setShowNotes} />}
            {openWorkflowModal2023 && <WorkflowCardModal2023 openWorkflowModal2023={openWorkflowModal2023} setOpenWorkflowModal2023={setOpenWorkflowModal2023} setShowNotes={props.setShowNotes} setWorkflows={setWorkflows} />}
            {workflowTemplateModal2023 && <WorkflowTemplateModal workflowTemplateModal2023={workflowTemplateModal2023} setWorkflowTemplateModal2023={setWorkflowTemplateModal2023} editWorkflow={editWorkflow} setEditWorkflow={setEditWorkflow} />}
            {error && <ErrorPopup error={error} setError={setError}/>}
        </div>
    )
}
export default AdminTasks